// SAR van render (M36.3, SAR-5): a box-rig — body + cab + four wheels — posed from
// the sim van's (pos, yaw). Client-only (ENG-1); the sim owns the drive model.
import * as THREE from 'three';
import type { Van } from '../../sim/vehicles/van';

const BODY = 0xdedede; // white van
const DARK = 0x1a1a1a;
const GLASS = 0x244a66;

export class VanRenderer {
  private readonly group = new THREE.Group();
  private readonly rigs = new Map<number, THREE.Group>();

  constructor(scene: THREE.Scene) { scene.add(this.group); }

  private buildRig(): THREE.Group {
    const rig = new THREE.Group();
    const body = new THREE.Mesh(new THREE.BoxGeometry(1.8, 1.6, 3.4), new THREE.MeshLambertMaterial({ color: BODY }));
    body.position.y = 1.0;
    const cab = new THREE.Mesh(new THREE.BoxGeometry(1.7, 0.6, 1.0), new THREE.MeshLambertMaterial({ color: GLASS }));
    cab.position.set(0, 1.5, -1.4);
    const wheelGeo = new THREE.CylinderGeometry(0.4, 0.4, 0.3, 10);
    const wheelMat = new THREE.MeshLambertMaterial({ color: DARK });
    for (const [wx, wz] of [[-0.9, -1.1], [0.9, -1.1], [-0.9, 1.1], [0.9, 1.1]] as const) {
      const w = new THREE.Mesh(wheelGeo, wheelMat);
      w.rotation.z = Math.PI / 2; w.position.set(wx, 0.4, wz);
      rig.add(w);
    }
    rig.add(body, cab);
    return rig;
  }

  update(vans: readonly Van[]): void {
    const seen = new Set<number>();
    for (const v of vans) {
      seen.add(v.id);
      let rig = this.rigs.get(v.id);
      if (!rig) { rig = this.buildRig(); this.rigs.set(v.id, rig); this.group.add(rig); }
      rig.position.set(v.x, v.y, v.z);
      rig.rotation.set(0, v.yaw, 0, 'YXZ');
    }
    for (const [id, rig] of this.rigs) {
      if (seen.has(id)) continue;
      this.group.remove(rig);
      rig.traverse((o) => { if (o instanceof THREE.Mesh) o.material.dispose(); });
      this.rigs.delete(id);
    }
  }

  clear(): void {
    for (const rig of this.rigs.values()) {
      this.group.remove(rig);
      rig.traverse((o) => { if (o instanceof THREE.Mesh) o.material.dispose(); });
    }
    this.rigs.clear();
  }
}
